export default "__VITE_ASSET__Cmf11jDc__"